import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { CenteredContainer } from "../components/CenteredContainer/CenteredContainer";

export interface IPageNotFoundViewProps {}

export const PageNotFoundView: React.FunctionComponent<IPageNotFoundViewProps> = (props: IPageNotFoundViewProps) => {
    const { t } = useTranslation();

    return (
        <CenteredContainer>
            <Typography variant="h4">{t("notFound.notFound")}</Typography>
            <p>{t("notFound.notFoundText")}</p>
        </CenteredContainer>
    );
};
